import i18n from 'i18next';
import { copyToClipboard, DataStatus, Dialog, DialogProps, TextInput } from 'platform/components';
import { useEffect } from 'react';
import { suffixTestId, TestIdProps } from 'shared/web';
import { SharePresetStateEnum } from '../../../../../../types/SharePresetState';
import { useSharePreset } from '../../hooks/useSharePreset';
const SHARE_PRESET_DIALOG_DELAY = 2000;
type SharePresetDialogProps = Omit<DialogProps, 'children' | 'isOpen'> & TestIdProps;
export function SharePresetDialog(props: SharePresetDialogProps) {
  const {
    shareUrl,
    sharePresetState,
    sharePreset,
    onClose
  } = useSharePreset(props.onClose);
  const onCopyToClipboard = () => {
    shareUrl && copyToClipboard(shareUrl);
  };

  // eslint-disable-next-line no-restricted-syntax -- intentional: cleanup-only useEffect with empty deps; useOnMount does not support cleanup returns; clearTimeout required if dialog unmounts within the 2-second delay
  useEffect(() => {
    const timeoutId = setTimeout(() => sharePreset(), SHARE_PRESET_DIALOG_DELAY);
    return () => clearTimeout(timeoutId);
  }, []);
  return <Dialog isOpen onClose={onClose} title={i18n.t('page.datagrid.labels.sharePresetDialogTitle')} buttons={[{
    title: i18n.t('general.actions.close'),
    variant: 'primary',
    onClick: onClose,
    'data-testid': suffixTestId('close', props)
  }]} data-testid={props['data-testid']}>
      <DataStatus isLoading={sharePresetState === SharePresetStateEnum.LOADING} isError={sharePresetState === SharePresetStateEnum.ERROR}>
        <TextInput label={i18n.t('page.datagrid.labels.sharePresetDialogUrl')} type="text" value={shareUrl} labelActions={[{
        title: i18n.t('general.actions.copyToClipboard'),
        leftIcon: 'content/copy',
        onClick: onCopyToClipboard
      }]} data-testid={suffixTestId('url', props)} />
      </DataStatus>
    </Dialog>;
}